import { Button, TextInput } from '@mantine/core';
import { useFocusWithin } from '@mantine/hooks';
import cx from 'clsx';
import { FC, memo } from 'react';
import { Icon } from 'src/components/Icon';

import styles from './styles.module.css';

type Props = {
  placeholder: string;
};

const isLoading = false;

export const SearchBar: FC<Props> = memo((props) => {
  const { ref, focused } = useFocusWithin();

  return (
    <TextInput
      ref={ref}
      classNames={{
        input: cx({
          [styles.input]: true,
          [styles.inputFocused]: focused,
          [styles.inputLoading]: isLoading,
        }),
        section: cx({
          [styles.section]: true,
          [styles.sectionLoading]: isLoading,
        }),
      }}
      // disabled={isLoading}
      withAsterisk={false}
      rightSection={
        <Button
          classNames={{
            root: cx({
              [styles.button]: true,
              [styles.buttonFocused]: focused,
              [styles.buttonLoading]: isLoading,
            }),
          }}
          loading={isLoading}
        >
          {!isLoading && (
            <Icon
              className={cx({
                [styles.icon]: true,
                [styles.iconFocused]: focused,
              })}
              name="search"
            />
          )}
        </Button>
      }
      {...props}
    />
  );
});
